import { useMemo } from 'react';

import { WorkloadScalingPolicy } from '@cast/types';

import { useAbility } from '@cast/shared-ability-data-access';
import { useIsWoopDemoMode } from 'features/workload-optimization';

export const useCanEditPolicy = () => {
  const abilityToUpdate = useAbility().can(
    'update',
    'ClusterWorkloadAutoscaler'
  );

  const isWoopDemoMode = useIsWoopDemoMode();

  const canEdit = useMemo(
    () => abilityToUpdate && !isWoopDemoMode,
    [abilityToUpdate, isWoopDemoMode]
  );

  return {
    canEdit,
    canEditPolicy: (policy?: WorkloadScalingPolicy) =>
      canEdit && !policy?.isCastware,
  };
};
